import React from 'react';
import styles from './index.module.less';
import { FooterContext } from '../../common';
import classNames from 'classnames';
import CompSubscribeInput from '@/components/SubscribeInput';

interface IFooterBrandInfoProps {
    langPack: Record<string, Record<string, string>>;
}

const CompFooterBrandInfo: React.FC<IFooterBrandInfoProps> = (props) => {
    const { getTextByKey, country } = React.useContext(FooterContext);
    return (
        <div className={ styles['logo-with-contact'] }>
            <div className={ styles['logo-content'] }>
                <div className={ styles['logo-box'] }>
                    <a
                        className={ classNames(styles['logo-link'], styles['logo-link-reolink']) }
                        href="https://www.reolink.com/"
                    >
                        <img
                            className={ styles['logo-image'] }
                            src="https://home-cdn.reolink.us/wp-content/assets/header-svg-white.svg"
                            alt="Reolink Logo"
                        />
                    </a>
                    <div className={ styles['divider'] }></div>
                    <a
                        className={ classNames(styles['logo-link'], styles['logo-link-camovue']) }
                        href="https://camovue.com"
                    >
                        <img
                            className={ styles['logo-image'] }
                            src="https://home-cdn.reolink.us/wp-content/assets/camovue_logo_web.svg"
                            alt="Camovue Logo"
                        />
                    </a>
                </div>
                <p className={ styles['brand-slogan'] }>{getTextByKey('reolink-slogan')}</p>
            </div>
            <div className={ styles['contact-us'] }>
                <p className={ styles['contact-us-title'] }>{getTextByKey('contact-us-title')}</p>
                <CompSubscribeInput
                    langPack={ props.langPack }
                    subject={ 'subscribe-for-business' }
                    country={ country } />
            </div>
        </div>
    );
};

export default CompFooterBrandInfo;
